import { mergeReducers } from './reducerCreater';
import ceilingHeightReducer from './ceilingHeight/ceilingHeightReducer';
import ceilingHeightDefaultState from './ceilingHeight/ceilingHeightDefaultState';
import undoable from 'redux-undo';
import { filterActions } from './filterActions';

const defaultState = {
  ...ceilingHeightDefaultState,
};

export default undoable(mergeReducers(defaultState, ceilingHeightReducer), {
  filter: filterActions,
  limit: 10,
});
